import { getLink } from '../../../../utils/utils';

const content = {
  rus: (
    `
      <div style="text-align: justify;">
        
        <p class="mb-3">
          В один прекрасный день весеннего месяца нисана решили две одесские эсперантистки на эсперантский Конгресс поехать. 
          Да не просто эсперантский, а Азиатский, который состоится в городе Иерусалиме, святом месте на Святой Земле. 
        </p>
        
        <p class="mb-3">
          Вот пишут они в Оргкомитет и спрашивают: «На каких условиях вы нас примете, ежели мы доклад сделаем, точно теме многоуважаемого Конгресса соответствующий, 
          да несколько фильмов, нами созданных на нашем любимом языке, представим, и даже семинар провести сможем?». 
          И ответили им руководители многоуважаемого Конгресса: «Да хоть сто докладов вы сделайте, хоть двести семинаров проведите – не видать вам ни скидок, 
          ни компенсаций, ни премий. 
          Хотите – участвуйте в работе, не хотите – не участвуйте, а платить вам всё равно придётся по полной!». 
        </p>
      
        <p class="mb-3">
          Заплакали тогда одесские эсперантистки, и ушли плача, и сидели они на берегу Чёрного моря и плакали. 
          И пришла к ним тогда идея здравая: «Поедем мы на Святую Землю, узнаем красоту её, наполним души наши чувствами высокими, в дружбе и братстве обретёмся, 
          как завещал нам наш Учитель – и отверзнутся перед нами врата Конгресса, хоть на один день!». 
        </p>
      
        <p class="mb-3">
          Напрягли они думы свои – и вспомнили, что живёт в той дальней стране много истинных друзей, в Эсперанто обретённых. 
          И один из этих друзей пригласил их в дом свой, дабы увидели они воочию всю прелесть и святость эсперантского Конгресса. 
          И приехали они, и встретил их добрый Павел.
        </p>
      
        <p class="mb-5">
          И было утро, и был вечер – день первый.
        </p>
        
      
      
        <p class="mb-5 bold text-center">* * *</p>
      
      
        <p class="mb-3">
          С раннего утра, ибо не отворилось ещё святилище Конгресса, пошли наши эсперантистки к другим святыням. 
          Море Галилейское, Назарет, долина Армагеддона, гора Фавора, река Иордан с местом Крещения; руины городов Тибериада, Магдала, Кана, Капернаум…
        </p>
      
        <p class="mb-3">
          В Назарете, в Храме Благовещения, много изображений Мадонны видели они, и среди подарков, присланных из разных стран, нашли они «Мадонну эсперантистов». 
          Под нею, вместо названия страны, слово Esperantos стояло, и Мадонна на фоне зелёной звезды изображена, и подписано было: 
          «Nia Sinjorino de la Espero, Patronino de la esperantistoj». 
          И эсперантисты тут же появились! 
          Это у них экскурсии перед Конгрессом были. 
          Так удалось нашим эсперантисткам с друзьями встретиться. 
          Не попали они на Конгресс – так Конгресс сам к ним пришёл! 
        </p>
    
        <p class="mb-5">
          И было утро, и был вечер – день второй.
        </p>
      
      
        <p class="mb-5 bold text-center">* * *</p>
      
      
        <p class="mb-3">
          Влекла наших эсперантисток земля неизведанная, и для третьего дня выбрали они тему всеобъемлющую: «Иерусалим – столица трёх религий». 
          Видели они кварталы армянский, еврейский, мусульманский и христианский. 
          Видели гору Сион и могилу царя Давида; видели Крестный Путь, гору Голгофу и Храм Гроба Господня. 
          Видели город Лод, где родился, жил и был похоронен Георгий Победоносец; видели древний город Рамла, основанный арабами 1400 лет назад. 
          Видели они монастырь Латрун и руины Эммауса, видели гробницу пророка Самуила на горе … много видели они в этот день. 
          Были в комнате Тайной Вечери, были у Стены Плача… 
          Видели долину Геенны Огненной… 
          Да, много видели они в этот день, и многое осталось в памяти навечно… 
        </p>
    
        <p class="mb-5">
          И было утро, и был вечер – день третий.
        </p>
    
        
        <p class="mb-5 bold text-center">* * *</p>
        
        
        <p class="mb-3">
          И вот зовёт снова наших эсперантисток земля дальняя, земля древняя. 
          И пришли они в долину, где растёт снежно-белая лилия Сарона, с которой сравнивал свою возлюбленную царь Соломон. 
          И перешли они через реку Александр, где побывал когда-то Александр Великий. 
          И пришли они в каменный город Акко, где правили крестоносцы, а перед ними – и финикийцы, и египтяне, и арабы. 
          Бродили по подземным лабиринтам, и замирали сердца от прикосновения к следам древности многих тысячелетий. 
        </p>
    
        <p class="mb-3">
          И были они в восьмом чуде света – Садах Бахаи. 
          Как торжественная лестница, восходят они по склонам горы Кармель; глубокая гармония исходит от их симметричного построения; 
          райской музыкой звучит вода, журчащая по обеим сторонам лестницы, сопровождая шаги идущих. 
          Символ вечной жизни, вечно звучит песня воды, ибо вода – это жизнь…
        </p>
    
        <p class="mb-3">
          И не забудем, что бахаи проповедуют необходимость одного общего языка для человечества, и этот язык – эсперанто. 
          Везде в этой чудесной стране присутствует эсперанто, и везде он связан с добрыми и святыми делами.
        </p>
    
        <p class="mb-5">
          И было утро, и был вечер – день четвёртый.
        </p>
        
        
        <p class="mb-5 bold text-center">* * *</p>
        
        
        <p class="mb-3">      
          Суббота, суббота, священный шабат! 
          Но вот это уже не за, а против эсперанто! 
          Сегодня решили эсперантистки поехать на Конгресс – но шабат не даёт! 
          Не смогут они вернуться домой после полного дня работы – автобусы перестают ходить после четырёх часов дня! 
          Ах, прощайте, прекрасные мечты о дружеских встречах, интересных докладах и восхитительных концертах! 
          Мы должны оставаться дома и – как странно, непривычно! – никуда не бежать, не стремиться, ничего не впитывать жадно, 
          стараясь не забыть такие яркие и сильные впечатления. 
          И только сейчас появляется возможность осознать в полную силу и в полном объёме всё то, что мы видели, слышали, трогали, воспринимали за эти дни, 
          равные многим месяцам по объёму полученных впечатлений. 
        </p>
      
        <p class="mb-5">
          И было утро, и был вечер – день пятый.
        </p>
        
        
        <p class="mb-5 bold text-center">* * *</p>
        
        
        <p class="mb-3">
          Тель-Авив – новый с иголочки город с множеством небоскрёбов, современными домами с садами на крышах, с Площадью Страны, где видно, 
          что две трети страны занимает пустыня. 
          Но как прекрасна и зелена оставшаяся треть! 
        </p>
    
        <p class="mb-3">
          Рамат-Ган. Парк сафари с зебрами, антилопами и страусами. 
          17 бегемотов в одном пруду. 
          Безумный слон, убивший свою подругу и теперь живущий в ссылке, подальше от своей семьи. 
          Обезьяны большие и маленькие, и много других симпатичных зверей.
        </p>
    
        <p class="mb-3">
          Яффа. Место, где был построен Ноев ковчег. 
          Скала Андромеды, где она была прикована для принесения в жертву, и где её спас Персей, возвращавшийся на Пегасе после победы над ужасной Медузой Горгоной. 
          Квартал художников, где улицы носят названия знаков зодиака… 
          Ах нет, по кварталу художников мы не успели побродить! 
          Бурный ливень смыл нас с его крутых наклонных улочек, выстланных такими скользкими жёлтыми плитками!
        </p>
    
        <p class="mb-5">
          И было утро, и был вечер – день шестой.
        </p>
        
        
        <p class="mb-5 bold text-center">* * *</p>
        
        
        <p class="mb-3">
          А День Седьмой был, естественно, днём отдыха. 
          Прочь – серьёзные темы! 
          Прочь – сильные впечатления и экскурсы в историю! 
          Три дня наши эсперантистки только загорали, купались и гуляли вечерами по оживлённым улицам города Эйлата, самой южной точки страны. 
          Рядом расстилается Красное море Индийского океана – знаменитое Красное море со своими кораллами, самыми живописными в мире! 
        </p>
    
        <p class="mb-3">
          Конечно, прежде всего надо было посетить Аквариум Эйлата, с его подводной Обсерваторией, где на глубине шести метров можно видеть настоящий, 
          живой коралловый риф с его обитателями, самыми экзотическими рыбами! 
          Черепахи, акулы, скаты; маленькие отдельные аквариумы, каждый со своей особой флорой и фауной; кораблик со стеклянным дном… 
          Демонстрация вскрытия раковин-жемчужниц, с обязательным нахождением внутри жемчужин, уже отполированных и даже с ушком для цепочки&#128512; 
          Огромный ювелирный магазин с жемчугами, бриллиантами, сапфирами, изумрудами 
          (в Эйлате не берут НДС, и, кроме того, там есть свой ювелирный завод, выпускающий также изделия из уникального «эйлатского камня»). 
        </p>
    
        <p class="mb-3">
          Город отдыха со множеством шикарных отелей, куда каждый может зайти и гулять там: полежать на шезлонгах в саду возле бассейна, 
          подняться на лифте на 12-й этаж, чтобы посмотреть сверху на весело сияющий огнями, беззаботный Эйлат…
        </p>
    
        <p class="mb-3">
          И везде – «Крокодилы, пальмы, баобабы…». 
          Восточная сказка. 
          Не удивительно, что наш Седьмой день длился несколько дольше обычного&#128512;.
        </p>
    
        <p class="mb-5">
          Но однако  было утро, и был вечер. А потом пришёл… 
        </p>
        
        
        <p class="mb-5 bold text-center">* * *</p>
        
        
        <p class="mb-3">
          День последний.
        </p>
    
        <p class="mb-3">
          По идее, это должен был быть понедельник. 
          А понедельник, как все знают – день тяжёлый. 
          И наши эсперантистки подтвердили это. 
          Для этого дня они выбрали самое тяжёлое дело – отдых на Мёртвом море.
        </p>
      
        <p class="mb-3">
          Да, это была тяжкая работа. 
          Войти в озеро почти невозможно, т.к. дно устлано очень острой соляной коркой и ранит ноги даже сквозь обувь. 
          Кроме того, большие волны встретили нас плеском и криком: «Подите прочь! Здесь не место для людей! Это Мёртвое море!». 
          Сурова здесь природа. Ведь недаром рядом находились когда-то Содом и Гоморра.
        </p>
    
        <p class="mb-3">
          Но люди покорили природу – и после соляного шторма так приятно было лежать, наслаждаясь, в радоновых, серных и прочих ваннах, 
          в тё-ё-ё-плой расслабляющей води-и-ичке…
        </p>
      
        <p class="mb-3">
          Назад – путь ведёт через пустыню. 
          Снова вспоминаются восточные сказки «1001 ночи», рассказы Тибора Секели о пройденных им пустынях.
        </p>
      
        <p class="mb-3">
          И всё же – мы нашли Эсперанто на Святой Земле!
        </p>
      
        <p class="mb-5">
          Спасибо организаторам Конгресса за эту предоставленную возможность! 
        </p>
        
        
        <p class="mb-3 text-end">
          <i style="font-size: 80%;">
          Было опубликовано в журнале REGO № 3 (76), junio 2013, на языке эсперанто.
          </i>
        </p>
        
        
        
        
        
        
      </div>
    
    `
  )
}

const itemName = {
  rus: 'Как две одесситки азиатский конгресс посетить решили, и что из этого вышло'
}

const itemDate = {
  rus: '2013 год'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemDate: itemDate.rus
  }
}
export default item;